import { useEffect } from "react";
import useLeaflet from "../hooks/useLeaflet";

const L: any = require("leaflet");
L.esri = require("esri-leaflet");

const featureServerURL =
  "https://services6.arcgis.com/QHir1urgnGYroCLG/ArcGIS/rest/services/Hav%C3%B8rred_Limfjorden/FeatureServer/2";

/*
 * This component displays the fiskelinjer on the map
 */

const Fiskelinjer = (_props) => {
  const context = useLeaflet();
  useEffect(() => {
    if (!context) return;
    const layer = L.esri.featureLayer({
      //fiskelinjer
      url: featureServerURL,
      style: { color: "#03a39b", weight: 4 },
    });

    layer.addTo(context.map);

    return () => {
      context.map.removeLayer(layer);
    };
  }, []);

  return null;
};

export default Fiskelinjer;
